<script>
	import { onMount, getContext } from "svelte";
	import { get } from "svelte/store";
	import AppStore from "../AppStore"
	import MapStore from "./Store"
	import MapLayerManager from "./MapLayerManager"

	import User from "../Branding/User";
	import Feature from "../Branding/Feature";
	import AuthStore from "../Auth/Store";
	import CustomMapDatasets from "./CustomMapDatasets";
	import ShippingLanesStore from "../ShippingLanes/Store";
	import MaritimeBoundariesStore from "../UI/MaritimeBoundaries/Store";
	import HydrographicChartStore from "../UI/HydrographicCharts/Store";

	const map = MapStore.mapbox.instance;

	let portClaimsVisible = null;
	let regionalClaimsVisible = null;

	let homeButton = null;
	let portsButton = null;
	let costsLayerButton = null;

	let setup = () => {
		const mapboxControlGroup = document.querySelector(
			"div.mapboxgl-ctrl:nth-child(2)"
		);

		
		
		
		// portsButton = mapboxControlGroup.firstChild.cloneNode();
		// portsButton.classList.remove("mapboxgl-ctrl-zoom-in");
		// portsButton.classList.remove("mapboxgl-ctrl-geollect-home");
		// portsButton.classList.add("mapboxgl-ctrl-geollect-port");
		// portsButton.title = "Ports";
		// portsButton.setAttribute("aria-label", "Ports");
		// mapboxControlGroup.insertBefore(portsButton, mapboxControlGroup.firstChild);
		// portsButton.addEventListener("click", (_) => {
		// 	// let lng = get(MapStore.homeLocation.lng);
		// 	// let lat = get(MapStore.homeLocation.lat);
		// 	// let zoom = get(MapStore.homeLocation.zoom);
		// 	// $map.flyTo({ center: [lng, lat], zoom: zoom });
		// 	// portsButton
		// 	MapStore.portsVisible.set(!get(MapStore.portsVisible));
		// });

		let addButton = (name, requiresFeature, storeVisible, cssSuffix = "") => {
			// Volcanoes
			let button = null;
			if (User.hasFeature(requiresFeature) || requiresFeature === null) {
				button = mapboxControlGroup.firstChild.cloneNode();

				button.classList.remove("mapboxgl-ctrl-geollect-shippinglanes");
				button.classList.remove("mapboxgl-ctrl-geollect-volcanoes");
				button.classList.remove("mapboxgl-ctrl-geollect-hurricanes");
				button.classList.remove("mapboxgl-ctrl-geollect-earthquakes");
				button.classList.remove("mapboxgl-ctrl-geollect-floods");
				button.classList.remove("mapboxgl-ctrl-geollect-warning");
				button.classList.remove("mapboxgl-ctrl-geollect-timezone");
				button.classList.remove("mapboxgl-ctrl-geollect-home");
				button.classList.remove("mapboxgl-ctrl-geollect-port");
				button.classList.remove("mapboxgl-ctrl-geollect-portassessments");
				button.classList.remove("mapboxgl-ctrl-geollect-maritimeboundaries");
				button.classList.remove("mapboxgl-ctrl-geollect-nauticalcharts");
				button.classList.remove("mapboxgl-ctrl-zoom-in");
				button.classList.remove("off");
				if (cssSuffix !== "") {
					button.classList.add("mapboxgl-ctrl-geollect-"+cssSuffix);
				}
				if (!get(storeVisible)) { button.classList.add("off"); }
				button.title = name;
				button.setAttribute("aria-label", name);
				mapboxControlGroup.insertBefore(button, mapboxControlGroup.firstChild);
				button.addEventListener("click", () => {
					storeVisible.set(!get(storeVisible));
					console.log('toggled:'+name, get(storeVisible));

					if (!get(storeVisible)) { button.classList.add("off"); }
					else { button.classList.remove("off"); }
				});
			}
			return button;
		};

		// addButton("Shipping Lanes Visibility", Feature.SHIPPING_LANES.VIEW, ShippingLanesStore.visible, "shippinglanes");
		// addButton("Ports", null, MapStore.portsVisible, "port");

		homeButton = mapboxControlGroup.firstChild.cloneNode();
		homeButton.classList.remove("mapboxgl-ctrl-zoom-in");
		homeButton.classList.remove("mapboxgl-ctrl-geollect-port");
		homeButton.classList.add("mapboxgl-ctrl-geollect-home");
		homeButton.title = "Home";
		homeButton.setAttribute("aria-label", "Home");
		mapboxControlGroup.insertBefore(homeButton, mapboxControlGroup.firstChild);
		homeButton.addEventListener("click", (_) => {
			let lng = get(MapStore.homeLocation.lng);
			let lat = get(MapStore.homeLocation.lat);
			let zoom = get(MapStore.homeLocation.zoom);
			$map.flyTo({ center: [lng, lat], zoom: zoom });
		});

		const id = get(AuthStore.userInfo).identity;
		if (id.toLowerCase().indexOf("standard_underwriters") !== -1) {
			portClaimsVisible = CustomMapDatasets.get("std_port_claims").visible;
			regionalClaimsVisible = CustomMapDatasets.get("std_regional_claims").visible;

			costsLayerButton = mapboxControlGroup.firstChild.cloneNode();

			costsLayerButton.classList.remove("mapboxgl-ctrl-zoom-in");
			costsLayerButton.classList.remove("mapboxgl-ctrl-geollect-port");
			costsLayerButton.classList.remove("mapboxgl-ctrl-geollect-warning");
			costsLayerButton.classList.remove("off");
			costsLayerButton.classList.add("mapboxgl-ctrl-geollect-costs");
			costsLayerButton.title = "Port/Regional Costs Visibility";
			costsLayerButton.setAttribute("aria-label", "Port/Regional Visibility");
			mapboxControlGroup.insertBefore(costsLayerButton, mapboxControlGroup.firstChild);
			costsLayerButton.addEventListener("click", () => {
				$portClaimsVisible = !$portClaimsVisible;
				$regionalClaimsVisible = !$regionalClaimsVisible;
				console.log('toggled claims:', $portClaimsVisible, $regionalClaimsVisible);
				if (!$portClaimsVisible) { costsLayerButton.classList.add("off"); }
				else { costsLayerButton.classList.remove("off"); }
				MapLayerManager.updateVisibleLayers();
			});
		}
	};

	let thisSetup = false;
	MapStore.meta.initialised.subscribe((initialised) => {
		if (initialised && !thisSetup)  {
			setup();
			thisSetup = true;
		}
	});

</script>

<!-- On mount add to the navigation controls -->
